import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/context/AuthContext";
import { SettingsProvider } from "@/context/SettingsContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import AuthCallback from "@/pages/AuthCallback";

import Home from "@/pages/Home";
import Capital from "@/pages/Capital";
import Media from "@/pages/Media";
import CRE from "@/pages/CRE";
import PrivateNetwork from "@/pages/PrivateNetwork";
import MichaelBrown from "@/pages/MichaelBrown";
import Aspire from "@/pages/Aspire";
import BookCall from "@/pages/BookCall";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import Dashboard from "@/pages/Dashboard";
import Admin from "@/pages/Admin";

function AppRouter() {
  const location = useLocation();
  if (location.hash?.includes("session_id=")) return <AuthCallback />;
  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/capital" element={<Capital />} />
      <Route path="/media" element={<Media />} />
      <Route path="/cre" element={<CRE />} />
      <Route path="/private-network" element={<PrivateNetwork />} />
      <Route path="/michael-brown" element={<MichaelBrown />} />
      <Route path="/aspire" element={<Aspire />} />
      <Route path="/book-call" element={<BookCall />} />
      <Route path="/login" element={<Login />} />
      <Route path="/register" element={<Register />} />
      <Route path="/dashboard" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
      <Route path="/admin" element={<ProtectedRoute adminOnly><Admin /></ProtectedRoute>} />
    </Routes>
  );
}

function App() {
  return (
    <div className="App">
      <SettingsProvider>
        <AuthProvider>
          <BrowserRouter>
            <AppRouter />
          </BrowserRouter>
          <Toaster theme="dark" position="top-right" richColors />
        </AuthProvider>
      </SettingsProvider>
    </div>
  );
}

export default App;
